export default __webpack_public_path__ + "images/B1.27b6cba.png";